import formatPhone from 'src/functions/formatPhone'
import {
  useAppointmentDataStore,
  useAuthorizationStore,
  useCalendarDataStore,
  useClubDataStore,
  useDoctorDataStore,
  useGlobalDataStore,
  useLpuDataStore,
  useUserDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import { useDoctorAutomaticScheduleChecks } from 'www/vue_components/common/AppointmentPage/subStores'
import type { DoctorAppointmentFormProps } from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/types'

export default function useMergePropsWithStores(props: DoctorAppointmentFormProps) {
  const clubDataStore = useClubDataStore()
  const lpuDataStore = useLpuDataStore()
  const globalDataStore = useGlobalDataStore()
  const doctorDataStore = useDoctorDataStore()
  const calendarDataStore = useCalendarDataStore()
  const authorizationStore = useAuthorizationStore() // todo(useAuthMt) - удалить
  const appointmentDataStore = useAppointmentDataStore()
  const doctorAutomaticScheduleChecks = useDoctorAutomaticScheduleChecks()

  doctorAutomaticScheduleChecks.customRequestLimit = props.initCalendarData.customRequestLimit

  if (appointmentDataStore.useAuthMt) {
    const userDataStore = useUserDataStore()

    userDataStore.userPhone = props.initUserData.phone
  } else if (props.initUserData.phone) {
    authorizationStore.userPhone = props.initUserData.phone
  }

  props.lpuData.phone = formatPhone({
    phone: props.lpuData.phone,
    country: { iso: window.COUNTRY_DATA.iso },
  })

  // @ts-ignore
  lpuDataStore.lpuData = props.lpuData

  doctorDataStore.doctorData = props.doctorData

  // @ts-ignore
  calendarDataStore.initCalendarData = props.initCalendarData

  appointmentDataStore.appointmentRegistrationTypes = props.appointmentRegistrationTypes
  appointmentDataStore.appointmentObjectTypes = props.appointmentObjectTypes

  if (props.appointmentCallTimes) {
    appointmentDataStore.appointmentCallTimes = props.appointmentCallTimes
  }

  appointmentDataStore.initAdditionalData = props.initAdditionalData

  // @ts-ignore
  globalDataStore.urls = props.urls

  if (props.initClubStatusData) {
    // @ts-ignore
    clubDataStore.clubStatusData = props.initClubStatusData
  }

  /** Далее логика, которая связана с успешной/неудачной записью на прием */

  if (props.initAppointmentStatusData.isError) {
    globalDataStore.updateErrorData({
      isEnabled: true,
      title: props.initAppointmentStatusData.title,
      subtitle: props.initAppointmentStatusData.subtitle,
      buttonState: props.initAppointmentStatusData.buttonState,
    })
  } else if (props.initAppointmentStatusData.isSuccess) {
    globalDataStore.updateSuccessData({
      isDialogRender: false,
      isEnabled: true,
      title: props.initAppointmentStatusData.title,
      subtitle: props.initAppointmentStatusData.subtitle,
      buttonState: props.initAppointmentStatusData.buttonState,
      medtochkaUrl: props.initAppointmentStatusData.medtochkaUrl,
      isEnableMedtochkaRedirect: props.initAppointmentStatusData.isEnableMedtochkaRedirect,
      showPhone: props.initAppointmentStatusData.code === 'has_recent_appointment_call',
    })
  }
}
